<template>
  <BaseButton
    icon="arrow-left"
    inverse-icon-order
    :theme-color="!primaryColor ? 'bg-secondary text-contrast-secondary' : ''"
    :title="includeTitle ? $t('button.back') : undefined"
    :size="size"
    @click="goBack"
  />
</template>

<script>
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'BackButton',
  components: { BaseButton },
  props: {
    includeTitle: {
      type: Boolean,
      default: false
    },
    fallbackRoute: {
      type: [Object, String],
      required: true
    },
    // names of the routes that are no use to go back to (the page itself reached again, its edit page...): when the
    // previous page of the application is one of them, or there is none, the button leaves for the fallback route
    skipRoutes: {
      type: Array,
      default: () => []
    },
    primaryColor: {
      type: Boolean,
      default: false,
      required: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: function (value) {
        return (
          ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
            value
          ) !== -1
        )
      }
    }
  },
  methods: {
    goBack() {
      if (
        !this.previousPageIsSkipped() &&
        (this.$route.redirectedFrom || window.history.length > 1)
      ) {
        this.$router.go(-1)
      } else {
        this.$router.push(this.fallbackRoute) // ou autre route nommée
      }
    },
    // vue-router keeps the address of the previous page of the application in the state of the history: null when
    // the page is the first one opened in the tab
    previousPageIsSkipped() {
      if (!this.skipRoutes.length) {
        return false
      }

      const previous = window.history.state?.back

      if (previous === null) {
        return true
      }

      return (
        typeof previous === 'string' &&
        this.skipRoutes.includes(this.$router.resolve(previous).name)
      )
    }
  }
}
</script>
